import {
  BlurLinear,
  Business,
  Filter1Outlined,
  Filter2Outlined,
  Gradient,
  Nfc,
  type SvgIconComponent,
} from "@mui/icons-material";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";

import { AUTH_ROLES } from "api/common/types/auth.types";
import { valueof } from "api/common/utils/type.utils";

type AuthRole = valueof<typeof AUTH_ROLES>;
export const TRAINING_CARD_TYPES = {
  REFERENCE: "reference",
  EVALUATION: "evaluation",
} as const;
export type trainingCardTypes = valueof<typeof TRAINING_CARD_TYPES>;

export interface TrainingCardConfig {
  title: string;
  description: string;
  slug: string;
  icon: SvgIconComponent;
  color: string;
  /**
   * Allowlist of roles that can see this card.
   * Omit entirely to make the card visible to all roles.
   */
  roles?: AuthRole[];
  type: trainingCardTypes;
}

const ALL_NON_VENDOR_ROLES: AuthRole[] = [
  AUTH_ROLES.NIAP,
  AUTH_ROLES.LAB,
  AUTH_ROLES.VALIDATOR,
];

export const TRAINING_CARDS: TrainingCardConfig[] = [
  {
    title: "Glossary",
    description: "Definitions for acronyms and terms.",
    slug: "glossary",
    icon: LibraryBooksIcon,
    color: "accent.main",
    type: TRAINING_CARD_TYPES.REFERENCE,
  },
  {
    title: "NIAP References",
    description: "Reference materials and resources for NIAP validators.",
    slug: "references",
    icon: Business,
    color: "accent.main",
    roles: [AUTH_ROLES.NIAP],
    type: TRAINING_CARD_TYPES.REFERENCE,
  },
  {
    title: "All Artifacts",
    description: "Browse all evaluation artifacts across both process stages.",
    slug: "all-artifacts",
    icon: Nfc,
    color: "accent.main",
    roles: ALL_NON_VENDOR_ROLES,
    type: TRAINING_CARD_TYPES.REFERENCE,
  },
  {
    title: "P1 Pre-Eval Flow",
    description: "Step-by-step guide through the pre-evaluation process.",
    slug: "p1-pre-evaluation",
    icon: Filter1Outlined,
    color: "success.main",
    roles: ALL_NON_VENDOR_ROLES,
    type: TRAINING_CARD_TYPES.EVALUATION,
  },
  {
    title: "P2 Eval Flow",
    description: "Step-by-step guide through the evaluation process.",
    slug: "p2-evaluation",
    icon: Filter2Outlined,
    color: "success.main",
    roles: ALL_NON_VENDOR_ROLES,
    type: TRAINING_CARD_TYPES.EVALUATION,
  },
  {
    title: "Progress Points",
    description:
      "Reference for all progress points in the evaluation lifecycle.",
    slug: "progress-points-reference",
    icon: BlurLinear,
    color: "accent.main",
    roles: ALL_NON_VENDOR_ROLES,
    type: TRAINING_CARD_TYPES.REFERENCE,
  },
  {
    title: "Evaluation Status",
    description: "Reference guide for evaluation status definitions.",
    slug: "evaluation-status-reference",
    icon: Gradient,
    color: "accent.main",
    roles: ALL_NON_VENDOR_ROLES,
    type: TRAINING_CARD_TYPES.REFERENCE,
  },
];
